// SEO helpers for canonical content pages.
// SEO helper utilities for canonical content renderers.

import { ASSETS } from '@airhead-games/shared/configs';
import type { Collection, Document } from '@airhead-games/shared/content';

export const getDocumentImage = (document: Document): string | undefined => {
  const imageAsset = document.seo.imageAsset ?? document.hero?.imageAsset;
  return imageAsset ? ASSETS[imageAsset] : undefined;
};

export const getCollectionImage = (
  collection: Collection
): string | undefined => {
  const imageAsset = collection.seo.imageAsset ?? collection.hero?.imageAsset;
  return imageAsset ? ASSETS[imageAsset] : undefined;
};
